import $ from 'jquery';
import Swiper from 'swiper';
import SlimSelect from 'slim-select';

import './header';
import './banner';
import './statistics';
import './statisticsNewsletterForm';
import './homeContactForm';
import './branchSearch';

if ($('.slim-select').length > 0) {
    new SlimSelect({
        select: '.slim-select'
    })
}

// Sub menu
$('.nav-links .has-sub-menu .extra-holder').click(function () {

    $(this).parent().toggleClass('show-sub-menu');

});


//change select in conyuntura
$('.coyuntura-col #year').change(function (e) {
    var value = $(this).val();

    window.location.href = location.protocol + '//' + location.host + location.pathname + '?' + value;
});

// Select en destacados

$('#select-destacados').click(function () {

    $('#list-destacados').toggleClass('opened');

});


$('#persona-fisica').change(function () {

    if ($(this).val() == 'juridica') {
        $('.field-nombre').hide();
        $('.field-dni').hide();
        $('.field-apellido').hide();
        $('.field-razon-social').css('display', 'flex');
        $('.field-cuit').css('display', 'flex');
        $('.textarea').css('margin-bottom', '140px');
    }

    if ($(this).val() == 'fisica') {
        $('.field-nombre').css('display', 'flex');
        $('.field-apellido').css('display', 'flex');
        $('.field-dni').css('display', 'flex');
        $('.field-razon-social').hide();
        $('.field-cuit').hide();
        $('.textarea').css('margin-bottom', '0px');
    }
});


$(document).ready(function () {

    //enviar sumate
    $('#enviar_form').click(function (e) {

        e.preventDefault();


        $('#open-contact form input,#open-contact form select,#open-contact form textarea').css('border', '0px');



        $('.notice-error').hide();
        var persona_fisica = $('#persona-fisica');
        var razon_social = $('#razon-social');
        var cuit = $('#cuit');
        var provincia = $('#provincia');
        var nombre = $('#nombre');
        var localidad = $('#localidad');
        var apellido = $('#apellido');
        var inscripcion_ieric = $('#inscripcion_ieric');
        var dni = $('#dni');
        var consultar_sobre = $('#consultar_sobre');
        var telefono = $('#telefono');
        var consulta = $('#consulta');
        var email = $('#email');



        if (persona_fisica.val() == '') {
            $('.notice-error').html('Ingrese la persona física').show();
            persona_fisica.css('border', '1px solid #e84a4a').focus();
            return false;
        } else {

            if (persona_fisica.val() == 'fisica') {
                if (nombre.val() == '') {
                    $('.notice-error').html('Ingrese el nombre').show();
                    nombre.css('border', '1px solid #e84a4a').focus();
                    return false;
                }

                if (apellido.val() == '') {
                    $('.notice-error').html('Ingrese el apellido').show();
                    apellido.css('border', '1px solid #e84a4a').focus();
                    return false;
                }

                if (dni.val() == '') {
                    $('.notice-error').html('Ingrese el dni').show();
                    dni.css('border', '1px solid #e84a4a').focus();
                    return false;
                }

            }

            if (persona_fisica.val() == 'juridica') {
                if (razon_social.val() == '') {
                    $('.notice-error').html('Ingrese el razón social').show();
                    razon_social.css('border', '1px solid #e84a4a').focus();
                    return false;
                }

                if (cuit.val() == '') {
                    $('.notice-error').html('Ingrese el cuit').show();
                    cuit.css('border', '1px solid #e84a4a').focus();
                    return false;
                }




            }
        }

        if (provincia.val() == '') {
            $('.notice-error').html('Ingrese la provincia').show();
            provincia.css('border', '1px solid #e84a4a').focus();
            return false;
        }



        if (localidad.val() == '') {
            $('.notice-error').html('Ingrese la localidad').show();
            localidad.css('border', '1px solid #e84a4a').focus();
            return false;
        }





        if (consultar_sobre.val() == '') {
            $('.notice-error').html('Ingrese el tipo de consulta').show();
            consultar_sobre.css('border', '1px solid #e84a4a').focus();
            return false;
        }

        if (telefono.val() == '') {
            $('.notice-error').html('Ingrese el teléfono').show();
            telefono.css('border', '1px solid #e84a4a').focus();
            return false;
        }

        if (consulta.val() == '') {
            $('.notice-error').html('Ingrese la consulta').show();
            consulta.css('border', '1px solid #e84a4a').focus();
            return false;
        }


        if (email.val() == '') {
            $('.notice-error').html('Ingrese el email').show();
            email.css('border', '1px solid #e84a4a').focus();
            return false;
        }



        $('#enviar_form').html('Enviando...');

        $.ajax({
            type: "POST",
            url: $('#domain').val() + "/ajax",

            data:
                "persona_fisica=" + persona_fisica.val() +
                "&razon_social=" + razon_social.val() +
                "&cuit=" + cuit.val() +
                "&nombre=" + nombre.val() +
                "&localidad=" + localidad.val() +
                "&apellido=" + apellido.val() +
                "&inscripcion_ieric=" + inscripcion_ieric.val() +
                "&dni=" + dni.val() +
                "&consultar_sobre=" + consultar_sobre.val() +
                "&provincia=" + provincia.val() +
                "&telefono=" + telefono.val() +
                "&consulta=" + consulta.val() +
                "&email=" + email.val() +
                "&tipo=contacto",
            success: function (html) {
                $('#enviar_form').html('Enviar');
                if (html == 'OK') {
                    $('#open-contact form').addClass('enviado');
                    $('#open-contact form').html('<p>Su mensaje ha sido enviado correctamente<br>  responderemos a la brevedad.</p>')
                }

                if (html != 'OK') {
                    $('.notice-error').html('No pudimos procesar tus datos, por favor intenta mas tarde!').show();
                }

            }
        });


    })


    $('.buttons .btn').click(function () {
        $('#razon-social').val('');
        $('#cuit').val('');
        $('#provincia').val('');
        $('#nombre').val('');
        $('#localidad').val('');
        $('#apellido').val('');
        $('#inscripcion_ieric').val('');
        $('#dni').val('');
        $('#consultar_sobre').val('');
        $('#telefono').val('')
        $('#consulta').val('');
        $('#email').val('');

        $.fancybox.close();
    });


    $('.ziehharmonika').ziehharmonika({
        collapsible: true,
    });


    $('.redirect-select').change(function () {
        window.location.replace($(this).val());
    });

    //series y estadisticas
    $('#series-estadisticas .item.closed').click(function (e) {
        e.preventDefault();
        $('#series-estadisticas .item.closed .ss-main').show();
    })

    //init fancybox
    $('[data-fancybox="gallery"]').fancybox({
        // Options will go here
    });

    $("a#inline").fancybox({
        'hideOnContentClick': true
    });

    // $("#fancy-box-opener").fancybox({
    //     'hideOnContentClick': true
    // });

    // $("#fancy-box-opener").attr('href', $('.gallery-holder .swiper-slide-active:not(.swiper-slide-duplicate) figure img').attr('src'));





    if ($('body').hasClass('home')) {

        //Slider vertical Home
        var mySwiper = new Swiper('.home .vertical-slider.swiper-container', {
            // Optional parameters

            direction: 'vertical',
            loop: true,
            slidesPerView: 3,
            spaceBetween: 20,
            freeMode: true,
            grabCursor: true,
            autoHeight: true,
            // autoplay: {
            //     delay: 3000,
            // },


            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
            },

            breakpoints: {
                // when window width is >= 320px

            }
        })

    } else {

        //Slider vertical
        var mySwiper = new Swiper('.vertical-slider.swiper-container', {
            // Optional parameters

            direction: 'horizontal',
            loop: true,
            slidesPerView: 1,
            // autoplay: {
            //     delay: 3000,
            // },

            // Navigation arrows
            navigation: {
                nextEl: '.next-btn',
            },

            breakpoints: {
                // when window width is >= 320px
                480: {
                    direction: 'vertical',
                    spaceBetween: 20
                },
            }
        })

    }



    //slider horizontal
    var mySwiper = new Swiper('.gallery-holder .swiper-container', {
        // Optional parameters
        //direction: 'vertical',
        //loop: true,
        autoHeight: true,
        //slidesPerView: 1,
        autoplay: {
            delay: 3000,
        },

        pagination: {
            el: '.gallery-holder .swiper-pagination',
            //dynamicBullets: true,
        },

        // Navigation arrows
        navigation: {
            nextEl: '.gallery-holder .swiper-button-next',
        },

    })
});